export const state = {
  lastScrollTop: 0,
  isLoading: false,
  loadingMessage: '',
  userAction: null,
};

export const mutations = {
  setLastScrollTop(state, newValue) {
    state.lastScrollTop = newValue;
  },
  showLoader(state, message) {
    state.isLoading = true;
    state.loadingMessage = message;
  },
  hideLoader(state) {
    state.isLoading = false;
    state.loadingMessage = null;
  },
  updateLoadingText(state, message) {
    state.loadingMessage = message;
  },
  setUserAction(state, value) {
    state.userAction = value;
  },
};

export const getters = {
  lastScrollTop: (state) => state.lastScrollTop,
};
export const gethelpers = ['lastScrollTop'];

export const actions = {
  setLastScrollTop({ commit }, { lastScrollTop }) {
    commit('setLastScrollTop', lastScrollTop);
  },
};

export const actionhelpers = ['setLastScrollTop'];
